//登録フロー：プロフィール画像、本名、ニックネーム登録 /namesRegister.js
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import { Link, browserHistory } from 'react-router';
import './css/namesRegister.css';
import './css/toast_custom.css';
import ToggleDisplay from 'react-toggle-display';
import { realNameRegister, nickNameRegister } from './firebase';

import Photoupdate from './photoUpdate2'
import users from './store/user';


export default class namesRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      realName: '',
      nickName: '',
      isInvalid: false,
      changePhoto: false,
      user: {},
      newImage: '',
      errorMessage: '',
    }
  }

  componentDidMount = () => {
    const nickName = users.getMyUser().displayName ? users.getMyUser().displayName : '';
    this.setState({nickName})
    const newImage = users.getMyUser().photoURL ? `${users.getMyUser().photoURL}?with=250&height=250` : '/img/common/m-profile-img.png';
    this.setState({newImage})
  }

  changePhoto = (e) => {
		e.preventDefault()		
		this.setState({ isChangePhoto: true })
	}

  handleRealNameChange = (e) => {
    this.setState({ realName: e.target.value });
  }

  handleNickNameChange = (e) => {
    this.setState({ nickName: e.target.value });
  }

  registerNames = () => {
    const realName = this.state.realName;
    const nickName = this.state.nickName;

    if (undefined === realName || 0 === realName.trim().length) {
      this.setState({ errorMessage: '※本名を入力してください'})
      this.setState({ isInvalid: true })
      return;
    } else if (undefined === nickName || 0 === nickName.trim().length) {
      this.setState({ errorMessage: '※ニックネームを入力してください'})
      this.setState({ isInvalid: true })
      return;
    }
    
    // 登録
    realNameRegister(realName);
    nickNameRegister(nickName);
    // 利用規約
    browserHistory.push('/newflow8');
    
  }

  changePhoto = (bool) => {
    this.setState({ changephoto: bool })
  }

  setNewImage = (newImage) => {
    this.setState({newImage})
  }

  setImage = () => {
    return this.state.newImage ? this.state.newImage : '/img/common/m-profile-img.png'
  }

  showContent = () => {
    const { changephoto } = this.state;
    if(changephoto) {
      console.log(users.getMyUser())
      return (
        <Photoupdate user={users.getMyUser()} changePhoto={this.changePhoto} setNewImage={this.setNewImage}/>
      )
    } else {
      return (
        <div className="content-top">
        <div className="block-names-register">
          <h2 className="title">Sign Up</h2>
          <img className="step_icon" src="/img/common/step-5@2x.png" alt="" />
          <img className="title_icon" src="/img/common/profile.svg" alt="" />
          <div>
            <p className="subtitle">プロフィール写真、本名、ニックネームを登録しよう！</p>
            <form className="form-names">
            <ToggleDisplay if={this.state.isInvalid}>
              <p>{this.state.errorMessage}</p>
            </ToggleDisplay>
            <div className="input-img">
              <img className="profile-img" src={this.setImage()} alt=""></img>
              <a onClick={this.changePhoto} className="btn-chan align-center">添付する</a>
            </div>

            <div className="input-name">
              <label className="input-label">本名</label>
              <input type="text" onChange={(e) => this.handleRealNameChange(e)} value={this.state.realName}></input>
              <label className="caution-statement">※本名が公開されることはありません</label>
            </div>

            <div className="input-name">
              <label className="input-label">ニックネーム（表示名）</label>
              <input type="text" onChange={(e) => this.handleNickNameChange(e)} value={this.state.nickName}></input>
            </div>

            </form>
            <div className="btnAction">
              <Link onClick={this.registerNames} className="btn-connect">次へ</Link>
            </div>
          </div>
        </div>
      </div>
      )
    }
  }

  render () {
    return (
      <div id="wrapper">
        <div id="" className="wrapper-lp wrapper-names-register">
          <Header parentProps={this.props} />
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
              {this.showContent()}
              </div>
              <Footer/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/namesRegister.js